module.exports = __webpack_public_path__ + "img/hollywoodSilk.feae6d8f.png";